<template>
    <div class="compliance-report-create-modal">
        <CoreTwoColumnsRow class="mb-3">
            <template #left>
                <CoreBorderWrapper
                    class="flex-grow-1 flex-shrink-1 flex-basis-40"
                    :condensed="true"
                >
                    {{ $t('§eq_operator.compliance_contract') }}
                </CoreBorderWrapper>
            </template>
            <template #right>
                <CoreDropdown
                    class="flex-grow-1 flex-shrink-1 flex-basis-60"
                    name="contract_id"
                    :placeholder="$t('§eq_operator.compliance_select_contract')"
                    :condensed="true"
                    :options="contractOptions"
                    optionLabel="label"
                    optionValue="value"
                    :modelValue="contractId"
                    @update:modelValue="contractId = $event"
                />
            </template>
        </CoreTwoColumnsRow>

        <div class="flex justify-start gap-2">
            <CoreButton
                label="§ui_button.save"
                icon="pi-save"
                @click="handleSave"
                :loading="saving"
                :disabled="!contractId"
            />

            <CoreButton
                variant="tertiary"
                label="§ui_button.cancel"
                icon="pi-times"
                @click="modalStore.setClose"
            />
        </div>
    </div>
</template>

<script>
import ApiService from '@/api/ApiService'
import ComplianceReportService from '@/api/ComplianceReportService.js'
import { useModalStore } from '@/stores/modal'
import { useClientStore } from '@/stores/client'
import CoreTwoColumnsRow from '@/components/core/CoreTwoColumnsRow.vue'
import CoreBorderWrapper from '@/components/core/CoreBorderWrapper.vue'
import CoreDropdown from '@/components/core/CoreDropdown.vue'
import CoreButton from '@/components/core/CoreButton.vue'

export default {
    name: 'ComplianceReportCreateModal',

    components: {
        CoreTwoColumnsRow,
        CoreBorderWrapper,
        CoreDropdown,
        CoreButton,
    },

    data() {
        return {
            contractOptions: [],
            contractId: null,
            saving: false,
            modalStore: useModalStore(),
            clientStore: useClientStore(),
        }
    },

    created() {
        this.fetchContracts()
    },

    methods: {
        async fetchContracts() {
            try {
                const { data } = await ApiService.get('client.contracts', {
                    client: this.clientStore.clientData.id,
                    not_having_report: 1,
                })
                this.contractOptions = Object.entries(data).map(([id, uid]) => ({
                    value: Number(id),
                    label: uid,
                }))
            } catch (error) {
                console.error('Error fetching contracts:', error)
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: this.$t('§ui_message.contracts_fetch_failed'),
                    life: this.$getToastDuration(),
                })
            }
        },

        async handleSave() {
            if (!this.contractId || this.saving) return
            this.saving = true
            try {
                const { data: report } = await ComplianceReportService.create(this.contractId, {})
                this.clientStore.incrementComplianceReportsVersion()
                this.modalStore.setClose()
                await this.$router.push({
                    name: 'ComplianceReportView',
                    params: { id: this.clientStore.clientData.id, reportId: report.id },
                })
            } catch (error) {
                console.error('Error creating compliance report:', error)
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: this.$t('§ui_message.compliance_report_create_failed'),
                    life: this.$getToastDuration(),
                })
            } finally {
                this.saving = false
            }
        },
    },
}
</script>

<style scoped>
.compliance-report-create-modal {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
}
</style>
